export default "/iphone.1c80a6a6-418877.png";